import { Icon } from "@iconify/react";
import { useState } from "react";
import env from "../../../../../config";

const UpgradeplanModal = ({ locationId }) => {
  const [open, setOpen] = useState(false);
  const [termsText, setTermsText] = useState("");

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleAppInstall = () => {
    const url = `https://app.gohighlevel.com/v2/location/${locationId}/integration/${env.GHL.APP_ID}`;
    window.open(url, "_blank");
  };
  return (
    <>
      <button
        className="btn btn-primary btn-sm rounded-3 shadow-sm d-flex align-items-center gap-2"
        onClick={handleOpen}
        title="Upgrade Plan"
      >
        <Icon icon="mdi:account-key-outline" width={18} />
        <span>Upgrade Plan</span>
      </button>

      {open && (
        <div
          className="modal fade show d-block"
          tabIndex={-1}
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content border-0 shadow-lg">
              {/* Header */}
              <div className="modal-header border-bottom-0 pb-0">
                <h5 className="modal-title fw-bold text-dark">
                  Upgrade Your Plan
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={handleClose}
                ></button>
              </div>

              {/* Body */}
              <div
                className="modal-body pt-2"
                style={{ maxHeight: "400px", overflowY: "auto" }}
              >
                {termsText ? (
                  <p className="text-muted" style={{ whiteSpace: "pre-line" }}>
                    {termsText}
                  </p>
                ) : (
                  <p className="text-muted">
                    No instructions have been added yet.
                  </p>
                )}
              </div>

              <div className="modal-footer border-top-0 pt-0">
                <button
                  type="button"
                  className="btn btn-secondary px-4"
                  onClick={handleClose}
                >
                  Close
                </button>
                <button
                  type="button"
                  className="btn btn-primary px-4"
                  onClick={handleAppInstall}
                >
                  Upgrade
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default UpgradeplanModal;
